/**
 * 관리자 감사 로그 전역 조회 API.
 * GET /admin/audit-logs — 기간·이벤트·수행자·대상 검색 + page/size.
 */
import { apiClient } from '@/shared/api/http-client';
import { createApiPath } from '@/shared/api/endpoints';

import type {
  AdminAuditLog,
  AdminAuditLogListParams,
  PageResponse,
} from '@/entities/admin-user/types';

export const auditLogService = {
  /**
   * 감사 로그 전역 목록.
   * pageable은 Spring 기본 flat 쿼리(`page`, `size`)로 전달한다.
   */
  list: async (
    params: AdminAuditLogListParams = {},
  ): Promise<PageResponse<AdminAuditLog>> => {
    const query: Record<string, string | number> = {};
    if (params.startDate !== undefined) query.startDate = params.startDate;
    if (params.endDate !== undefined) query.endDate = params.endDate;
    if (params.eventType !== undefined) query.eventType = params.eventType;
    if (params.actorUsername !== undefined) {
      query.actorUsername = params.actorUsername;
    }
    if (params.targetQuery !== undefined) {
      query.targetQuery = params.targetQuery;
    }
    if (params.page !== undefined) query.page = params.page;
    if (params.size !== undefined) query.size = params.size;

    const response = await apiClient.get(createApiPath.auditLogs.list(), {
      params: query,
    });
    return response.data;
  },
};
